import { BaseAccordion } from "@/components/ui";
import { AccordionData } from "../../../config/landingPageConfig.tsx";

export const Faq = () => {
  return (
    <div
      id="support"
      className="lg:px-10 px-5 py-20 items-center justify-center flex-col flex"
    >
      <div className="grid items-start grid-cols-1 space-y-5 lg:grid-cols-2 w-full">
        <div className={` flex-col justify-start   flex gap-5`}>
          <p className="text-white md:text-3xl max-w-sm text-2xl lg:text-5xl leading-[56px]">
            Frequently asked question
          </p>
          <p className="md:text-lg text-base lg:text-xl max-w-md leading-[28px] text-[#FFFFFF99]">
            No matter what project you're working on, we've got you covered with
            the best wireframe kits for any platform.
          </p>
        </div>
        <BaseAccordion {...AccordionData} />
      </div>
    </div>
  );
};
